export default "__VITE_ASSET__Cst_IjX___"